import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditing,
  selectOptionFromKey,
  updateOtherOption,
  updateSelectedOption,
} from "../../customisation-slice";
import EditingOption from "./editing-option";
import PropTypes from "prop-types";
import { isValueSteelColor } from "../../support/helpers";

const propTypes = {
  editingOptions: PropTypes.instanceOf(Object).isRequired,
  selectedOption: PropTypes.string,
};

const EditingGrid = ({ editingOptions, selectedOption }) => {
  const dispatch = useDispatch();
  const editingKey = useSelector(selectEditing);
  const strapState = useSelector((state) =>
    selectOptionFromKey(state, "strap")
  );

  useEffect(() => {
    const optionsList = document.getElementById("options-list");
    optionsList.scrollLeft = 0;
  }, [editingOptions]);

  const selectOption = (selection) => {
    if (editingKey === "case" && isValueSteelColor(strapState.selected)) {
      if (isValueSteelColor(selection)) {
        return updateCaseAndStrap(selection, selection);
      }

      return updateCaseAndStrap(selection, "aqua");
    }
    dispatch(updateSelectedOption(selection));
  };

  const updateCaseAndStrap = (caseValue, strapValue) => {
    dispatch(updateOtherOption({ optionKey: "case", value: caseValue }));
    dispatch(updateOtherOption({ optionKey: "strap", value: strapValue }));
  };

  return (
    <div
      id="options-list"
      className="flex-grow flex flex-row md:grid grid-cols-2 md:content-start overflow-y-auto"
    >
      {Object.keys(editingOptions).map((key) => {
        const optionValue = editingOptions[key];
        return (
          <EditingOption
            key={key}
            optionValue={optionValue}
            optionKey={key}
            selectedOption={selectedOption}
            onClick={() => selectOption(key)}
            editingKey={editingKey}
          />
        );
      })}
    </div>
  );
};

EditingGrid.propTypes = propTypes;

export default EditingGrid;
